import script from "./PlayerBets.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerBets.vue?vue&type=script&setup=true&lang=js"

import "./PlayerBets.vue?vue&type=style&index=0&id=48f1c4ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48f1c4ab"]])

export default __exports__